var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "chat_discussion",
      staticClass: "chat-discussion",
      class:
        !_vm.userHasAcceptedTerms && !this.$userIsAdmin && !_vm.adminThread
          ? "terms-height"
          : null,
      attrs: { id: "chat-discussion" },
    },
    [
      _vm.thread && _vm.thread.id
        ? _c("div", [
            !_vm.userHasAcceptedTerms && !this.$userIsAdmin && !_vm.adminThread
              ? _c("div", [_c("thread-accept-terms")], 1)
              : _c(
                  "div",
                  _vm._l(_vm.thread.messages, function (message) {
                    return _c("thread-discussion-message", {
                      key: message.id,
                      attrs: {
                        message: message,
                        readers: _vm.lastReadBy(message),
                      },
                    })
                  }),
                  1
                ),
          ])
        : _c("div", [_c("pickstar-loading", { staticClass: "m-t-lg" })], 1),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }